export async function getRecaptchaToken(
    action: string
): Promise<string | null> {
    const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY
    if (!siteKey) {
        console.warn('NEXT_PUBLIC_RECAPTCHA_SITE_KEY is not defined')
        return null
    }

    try {
        if (!grecaptcha || !grecaptcha.enterprise) {
            console.warn('reCAPTCHA is not loaded')
            return null
        }
        const token = await grecaptcha.enterprise.execute(siteKey, {
            action,
        })
        return token
    } catch (error) {
        console.error('Error getting reCAPTCHA token:', error)
        return null
    }
}

export async function verifyRecaptchaToken(
    token: string,
    expectedAction: string
): Promise<boolean> {
    const googleApiKey = process.env.GOOGLE_API_KEY
    if (!googleApiKey) {
        console.warn('GOOGLE_API_KEY is not defined')
        return false
    }
    const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY
    if (!siteKey) {
        console.warn('NEXT_PUBLIC_RECAPTCHA_SITE_KEY is not defined')
        return false
    }
    const googleProjectId = process.env.GOOGLE_PROJECT_ID
    if (!googleProjectId) {
        console.warn('GOOGLE_PROJECT_ID is not defined')
        return false
    }

    // console.log({ token, siteKey, expectedAction })

    try {
        const response = await fetch(
            `https://recaptchaenterprise.googleapis.com/v1/projects/${googleProjectId}/assessments?key=${googleApiKey}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    event: {
                        token,
                        expectedAction,
                        siteKey,
                    },
                }),
            }
        )

        const data = await response.json()
        // console.log('reCAPTCHA verification response:', data)

        const scoreThreshold = 0.5
        const score = data?.riskAnalysis?.score || 0

        const isScoreAcceptable = score >= scoreThreshold

        if (!isScoreAcceptable || data?.tokenProperties?.valid !== true) {
            console.warn(
                'reCAPTCHA verification failed or score too low',
                JSON.stringify(data, null, 2)
            )
            return false
        }

        return true
    } catch (error) {
        console.error('Error verifying reCAPTCHA token:', error)
        return false
    }
}
